import React, { useContext, useState } from "react";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import TextInput from "./TextInput";
import { useCrackersFilters } from "../hooks/useCrackersFilters";
import Select from 'react-select';
import { useCrackersCategories } from "../hooks/useCrackersCategories";
import { CrackersContext } from "../CrackersContext";
import { raiseGetRequest, raisePostRequest } from "../AxiosAPI";

function AdminCrackersAdding () {
    const [agentNo, setAgentNo] = useState('');
    const [crackers, setCrackers] = useState('');
    const [crackersId, setCrackersId] = useState(-1);
    const [category, setCategory] = useState('Day time');
    const [ageGroup, setAgeGroup] = useState('All');
    const [type, setType] = useState('Sound');
    const [mrp, setMrp] = useState(0.0);
    const [incrPerc, setIncrPerc] = useState(12.5);
    const [sellingPrice, setSellingPrice] = useState(0.0);
    const [agentPrice, setAgentPrice] = useState(0);
    const [offerPrice, setOfferPrice] = useState(0.0);
    const [page, setPage] = useState(1);
    const [image1, setImage1] = useState("/client/images/Image_not_available.png");
    const [image2, setImage2] = useState("/client/images/Image_not_available.png");
    const [image3, setImage3] = useState("/client/images/Image_not_available.png");
    const [image4, setImage4] = useState("/client/images/Image_not_available.png");
    const imageSetters = [setImage1, setImage2, setImage3, setImage4];
    const [description, setDescription] = useState("");
    const { filters, filterLoading, filterError } = useCrackersFilters();
    const { crackersCategory, setShowErrorToastStatus, setToastBody } = useContext(CrackersContext);

    const [selectedOption, setSelectedOption] = useState("");
    const [crackersList, setCrackersList] = useState([]);

    const [addBtnStatus, setAddBtnStatus] = useState(false);
    const [updateBtnStatus, setUpdateBtnStatus] = useState(false);

    const clear = () => {
        setCrackers('');
        setCategory('Day time');
        setAgeGroup('All');
        setType('Sound');
        setMrp(0);
        setSellingPrice(0);
        setAgentPrice(0);
        setOfferPrice(0);
        setDescription("");

        setImage1("");
        setImage2("");
        setImage3("");
        setImage4("");
        setIncrPerc("");

        setAddBtnStatus(false);
        setAddBtnStatus(false);
    }

    const changeCategory = (eventKey, event) => {
        setCategory(eventKey);
    }

    const changeFilter = (eventKey, event) => {
        setAgeGroup(eventKey);
    }

    const changeType = (eventKey, event) => {
        setType(eventKey);
    }

    const addCrackers = async () => {
        var requestUri = `/admin/agents/${agentNo}/crackers`;
        var payload = {
            "crackers_name" : crackers,
            "category" : category,
            "filter" : ageGroup,
            "type" : type,
            "mrp" : mrp,
            "selling_price" : sellingPrice,
            "offer_price" : offerPrice,
            "agent_price" : agentPrice,
            "page" : page
        }
        var response = await raisePostRequest(requestUri, payload, null, setShowErrorToastStatus, setToastBody);
        var id = response.id;
        payload = {
            "links" : JSON.stringify([image1, image2, image3, image4])
        }
        requestUri = requestUri = `/admin/agents/${agentNo}/crackers/${id}/resources`;
        response = await raisePostRequest(requestUri, payload, null, setShowErrorToastStatus, setToastBody);

        var newCrackersArray = crackersList;
        newCrackersArray.push({value : id, label : crackers});
        setCrackersList(newCrackersArray);
        clear();
    }

    const updateCrackers = async () => {
        if(crackersId == -1) {
            alert("Invalid crackers ID");
        }
        var requestUri = `/admin/agents/${agentNo}/crackers/${crackersId}`;
        var payload = {
            "crackers_name" : crackers,
            "category" : category,
            "filter" : ageGroup,
            "type" : type,
            "mrp" : mrp,
            "selling_price" : sellingPrice,
            "offer_price" : offerPrice,
            "agent_price" : agentPrice,
            "page" : page,
            "description" : description
        }
        var response = raisePostRequest(requestUri, payload, null, setShowErrorToastStatus, setToastBody);

        payload = {
            "links" : JSON.stringify([image1, image2, image3, image4])
        }
        requestUri = requestUri = `/admin/agents/${agentNo}/crackers/${crackersId}/resources`;
        response = await raisePostRequest(requestUri, payload, null, setShowErrorToastStatus, setToastBody);

        clear();
    }

    const validateAgent = async (agentNumber) => {
        var requestUri = `/admin/agents/${agentNumber}`;
        var response = await raiseGetRequest(requestUri, null, null, null);
        if(response.status && response.status === "failure") {
            alert(response.error_message);
        }

        requestUri = `/admin/agents/${agentNumber}/crackers`;
        response = await raiseGetRequest(requestUri, null, null, null);
        var crackersArray = [];
        for(let i=0; i<response.length; i++) {
            let crackers = response[i];
            crackersArray.push({value : crackers.id, label : crackers.name})
        }
        setCrackersList(crackersArray);
    }

    const getCrackers = async (selected) => {
        var requestUri = `/admin/agents/${agentNo}/crackers/${selected.value}`;
        const crackers = await raiseGetRequest(requestUri);
        setCrackers(crackers.crackersName);
        setCrackersId(selected.value);
        setSelectedOption(crackers.crackersName);
        setMrp(crackers.mrp);
        setSellingPrice(crackers.selling_price);
        setAgentPrice(crackers.agent_price);
        setOfferPrice(crackers.offer_price);
        setPage(crackers.page);
        setDescription(crackers.description);

        setCategory(crackers.category);
        setAgeGroup(crackers.filter);
        setType(crackers.type);
        

        setIncrPerc((((crackers.offer_price - crackers.agent_price) / crackers.agent_price)) * 100)
        setImage1("/client/images/Image_not_available.png");
        setImage2("/client/images/Image_not_available.png");
        setImage3("/client/images/Image_not_available.png");
        setImage4("/client/images/Image_not_available.png");
        if(crackers.images) {
            for(let i=0; i<crackers.images.length; i++) {
                imageSetters[i](crackers.images[i]);
            }
        }

        setAddBtnStatus(false);
        setUpdateBtnStatus(true);
    }

    const calcPrice = () => {
        if(agentPrice > 0) {
            setOfferPrice(Math.ceil(Number(((agentPrice/100) * incrPerc)) + Number(agentPrice)));
        }
    }

    const changeCrackersName = (value) => {
        setCrackers(value);
        setCrackersId(-1);
        setAddBtnStatus(true);
        setUpdateBtnStatus(false);
    }

    return(
        <>
            <Row>
                <Col lg={1}></Col>
                <Col lg={2}>
                    <TextInput caption={"Agent Mob Number"}
                                value={agentNo}
                                onChange={setAgentNo}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Agent Mob Number"}
                                validator={validateAgent}
                                isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <div className="container mt-3" style={{ maxWidth: 400 }}>
                        <Select
                            options={crackersList}
                            value={selectedOption}
                            onChange={(selected) => getCrackers(selected)}
                            placeholder="Select Crackers..."
                            isSearchable
                        />
                    </div>
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={4}>
                    <TextInput caption={"Crackers Name"}
                                value={crackers}
                                onChange={changeCrackersName}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Crackers Name"}
                                validator={null}
                                isMultiLine={false} />
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={2}>
                    <label><b>Category</b></label>
                </Col>
                <Col lg={2}>
                    <Dropdown className="cl_dd" onSelect={changeCategory}>
                        <Dropdown.Toggle variant="primary">
                            {category}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {crackersCategory.map((categoryName) => (
                                <Dropdown.Item key={'admin_category_' + categoryName.id} eventKey={categoryName.category}>{categoryName.category}</Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={2}>
                    <label><b>Age Group</b></label>
                </Col>
                <Col lg={2}>
                    <Dropdown className="cl_dd" onSelect={changeFilter}>
                        <Dropdown.Toggle variant="primary">
                            {ageGroup}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {!filterLoading && !filterError && filters.map((filter) => (
                                <Dropdown.Item key={'admin_filter_' + filter.id} eventKey={filter.filter}>{filter.filter}</Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={2}>
                    <label><b>Type</b></label>
                </Col>
                <Col lg={2}>
                    <Dropdown className="cl_dd" onSelect={changeType}>
                        <Dropdown.Toggle variant="primary">
                            {type}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item key={'admin_type_1'} eventKey={'Sound'}>{'Sound'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_2'} eventKey={'Rocket'}>{'Rocket'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_3'} eventKey={'Garland'}>{'Garland'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_4'} eventKey={'Flower pots'}>{'Flower pots'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_5'} eventKey={'Twinkling star'}>{'Twinkling star'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_6'} eventKey={'Pencil'}>{'Pencil'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_7'} eventKey={'Sparklers'}>{'Sparklers'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_8'} eventKey={'Fancies'}>{'Fancies'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_9'} eventKey={'Single shot comet'}>{'Single shot comet'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_10'} eventKey={'Multi shot comet'}>{'Multi shot comet'}</Dropdown.Item>
                            <Dropdown.Item key={'admin_type_11'} eventKey={'Combo'}>{'Combo'}</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={2}>
                    <TextInput caption={"MRP"}
                                value={mrp}
                                onChange={setMrp}
                                validation={{}}
                                info={""}
                                onFocusCaption={"MRP"}
                                validator={null}
                                isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <TextInput caption={"Incr %"}
                                value={incrPerc}
                                onChange={setIncrPerc}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Incr %"}
                                validator={calcPrice}
                                isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <TextInput caption={"Image 1"}
                            value={image1}
                            onChange={setImage1}
                            validation={{}}
                            info={""}
                            onFocusCaption={"Image 1"}
                            validator={null}
                            isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <img style={{width :"80px", height : "80px"}} src={image1} />
                </Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={4}>
                    <TextInput caption={"Selling Price"}
                                value={sellingPrice}
                                onChange={setSellingPrice}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Selling Price"}
                                validator={null}
                                isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <TextInput caption={"Image 2"}
                            value={image2}
                            onChange={setImage2}
                            validation={{}}
                            info={""}
                            onFocusCaption={"Image 2"}
                            validator={null}
                            isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <img style={{width :"80px", height : "80px"}} src={image2} />
                </Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={2}>
                    <TextInput caption={"Agent Price"}
                                value={agentPrice}
                                onChange={setAgentPrice}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Agent Price"}
                                validator={calcPrice}
                                isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <TextInput caption={"Offer Price"}
                                value={offerPrice}
                                onChange={setOfferPrice}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Offer Price"}
                                validator={null}
                                isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <TextInput caption={"Image 3"}
                            value={image3}
                            onChange={setImage3}
                            validation={{}}
                            info={""}
                            onFocusCaption={"Image 3"}
                            validator={null}
                            isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <img style={{width :"80px", height : "80px"}} src={image3} />
                </Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={4}>
                    <TextInput caption={"Page"}
                                value={page}
                                onChange={setPage}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Page"}
                                validator={null}
                                isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <TextInput caption={"Image 4"}
                            value={image4}
                            onChange={setImage4}
                            validation={{}}
                            info={""}
                            onFocusCaption={"Image 4"}
                            validator={null}
                            isMultiLine={false} />
                </Col>
                <Col lg={2}>
                    <img style={{width :"80px", height : "80px"}} src={image4} />
                </Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={2}>
                    <label><b>Description</b></label>
                </Col>
                <Col lg={2}>
                    <TextInput caption={"Description"}
                                value={description}
                                onChange={setDescription}
                                validation={{}}
                                info={""}
                                onFocusCaption={"Description"}
                                validator={null}
                                isMultiLine={true} />
                </Col>
                <Col lg={4}></Col>
            </Row>

            <Row>
                <Col lg={1}></Col>
                <Col lg={4}></Col>
                <Col lg={1}>
                    <Button onClick={addCrackers} disabled={!addBtnStatus}>Add</Button>
                </Col>
                <Col lg={1}>
                    <Button onClick={updateCrackers} disabled={!updateBtnStatus}>Update</Button>
                </Col>
                <Col lg={2}></Col>
            </Row>

        </>
    )
}

export default AdminCrackersAdding;